import Instagram from "./instagram";

export { Instagram };
export default Instagram;
